// extracted by mini-css-extract-plugin
export default {"token":"NFFr1"};